function currentYPosition() {
  // Firefox, Chrome, Opera, Safari
  if (window.self.pageYOffset) return window.self.pageYOffset;
  // Internet Explorer
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(eID) {
  const elm = document.getElementById(eID.replace(/^#/, ""));
  let y = elm.offsetTop;
  let node = elm;

  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

/**
 * Use `href="#anchorID"` in your hyperlinks with
 * `smoothScroll('destinationAnchorID');return false;`
 * as the onclick event.
 *
 * @see http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript
 * @example
 *  <a href="#anchor-1" onclick="smoothScroll('anchor-1');return false;">smooth scroll to Anchor 1<a/>
 */
export function smoothScroll(eID, duration = 500) {
  const startingY = currentYPosition();
  const diff = elmYPosition(eID) - startingY;
  let start;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    // Elapsed miliseconds since start of scrolling.
    const time = timestamp - start;
    // Get percent of completion in range [0, 1].
    const percent = Math.min(time / duration, 1);

    window.scrollTo(0, startingY + diff * percent);

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}
